import { useCallback, useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from '../../../context'
import AuthService from '../../../services/auth-service'

const useResetPassword = () => {
  const [token, setToken] = useState(null)
  const [registering, setRegistering] = useState(null)
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()

  const authContext = useContext(AuthContext)

  const [inputs, setInputs] = useState({
    password: '',
    password_confirmation: '',
  })

  const [errors, setErrors] = useState({
    passwordError: false,
    confirmError: false,
    error: false,
    textError: '',
  })

  const handleChange = useCallback(
    e => {
      setInputs({
        ...inputs,
        [e.target.name]: e.target.value,
      })
    },
    [inputs],
  )

  useEffect(() => {
    // get the token sent in the url
    const queryParams = new URLSearchParams(window.location.search)
    setToken(queryParams.get('token'))
    if (queryParams.get('registering') === '1') {
      setRegistering(true)
    } else {
      setRegistering(false)
    }
  }, [])

  const handleSubmit = useCallback(
    async e => {
      e.preventDefault()

      let errors = {}
      if (inputs.password.trim().length < 8) {
        errors = { ...errors, passwordError: true }
      }

      if (inputs.password_confirmation.trim() !== inputs.password.trim()) {
        errors = { ...errors, confirmError: true }
      }

      setErrors(errors)
      if (Object.keys(errors).length > 0) {
        return
      }

      setLoading(true)
      try {
        if (registering) {
          const response = await AuthService.createAccount({
            token,
            password: inputs.password,
          })
          authContext.login(response.access_token, true)
        } else {
          const response = await AuthService.resetPassword({
            token,
            password: inputs.password,
          })
          authContext.login(response.access_token, true)
        }
        navigate('/home')

        setLoading(false)

        setInputs({
          password: '',
          password_confirmation: '',
        })

        setErrors({
          passwordError: false,
          confirmError: false,
          error: false,
          textError: '',
        })
      } catch (err) {
        if (registering && err?.response?.status === 400) {
          setErrors({ ...errors, error: true, textError: 'Ai deja cont!' })
        } else {
          setErrors({
            ...errors,
            error: true,
            textError:
              'A apărut o eroare neprevazută. Dacă persistă, te rugăm să ne contactezi.',
          })
        }

        return null
      } finally {
        setLoading(false)
      }
    },
    [inputs, registering, authContext, navigate, token],
  )

  return { handleChange, handleSubmit, registering, inputs, errors, loading }
}

export default useResetPassword
